// export * from './mousemove'
import step from './step'
import click from './click'
import navigation from './navigation'
import viewport from './viewport'
import scroll from './scroll'
import keyboard from './keyboard'
import domchange from './domchange'
import request from './request'
import screenshot from './screenshot'
import file from './file'
import record from './record'
import mocker from './mocker'
import coverage from './coverage'
import hook from './hook'
import {Plugin} from '../types'
import {loadConfig} from '../config';

const plugins = {
  step,
  click,
  navigation,
  viewport,
  scroll,
  keyboard,
  domchange,
  request,
  mocker,
  record,
  screenshot,
  file,
  coverage,
  hook
}
// export default plugins
const config = loadConfig()
let actions: Record<string, Plugin> = {}
if(!Object.keys(config.actions).length){
  actions = plugins
}else{
  for (const action in config.actions){
    if(plugins[action]){
      actions[action] = plugins[action]
    }else{
      const customAction:Plugin = {
        name: action,
        ...config.actions[action]
      }
      actions[action] = customAction
    }  
  }
}
export default actions